import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EnvService } from 'src/app/env.service';

@Component({
  selector: 'app-hub-history',
  templateUrl: './hub-history.component.html',
  styleUrls: ['./hub-history.component.css']
})

export class HubHistoryComponent implements OnInit {

  localData;
  loading=true;

  displayedColumnsForTransfer: string[] = ['fromUser', 'toUser', 'fromHubId','invokerEmailId' , 'invokedTime','removeAcls','status'];
  displayedColumnsForReplaceMent: string[] = ['toUser', 'fromHubId', 'toHubId', 'invokerEmailId', 'invokedTime', 'status'];
  displayedColumnsForComDcom: string[] = ['type', 'date'];
  dataSourceForTransfer=[];
  dataSourceForReplacement=[];
  dataSourceForComDcom=[]; 

  constructor(@Inject(MAT_DIALOG_DATA) public data : any, private http: HttpClient, private env: EnvService, private router: Router) { }

  ngOnInit(): void {
    this.http.get(this.env.apiUrl+"/api/users/hubHistory/" + this.data.hubId)
    .subscribe(response=>{
      this.localData = response
      this.setHistoryData();
      this.loading=false;
    },err=>{
      console.log(err);
      this.loading=false;
    })
  }

  setHistoryData(){
    this.dataSourceForTransfer = this.localData.hubHistoryData.hubHistory.filter(item=>item.Type=="TRANSFER").sort(function(a,b){return b.invokedTime>a.invokedTime?1:-1});
    this.dataSourceForReplacement = this.localData.hubHistoryData.hubHistory.filter(item=>item.Type=="REPLACEMENT").sort(function(a,b){return b.invokedTime>a.invokedTime?1:-1});  
    var comHistory=this.localData.hubHistoryData.comDcomHistory.comHistory;
    var dcomHistory=this.localData.hubHistoryData.comDcomHistory.dcomHistory;
    comHistory.map(item=>{
      this.dataSourceForComDcom.push({
        'type':'Commission',
        'date': item
      })
    });
    dcomHistory.map(item=>{
      this.dataSourceForComDcom.push({
        'type':'Decommission',
        'date': item
      })
    })
    this.dataSourceForComDcom.sort(function(a,b){return b.date>a.date?1:-1});
  }

}
